import { useRouter } from 'next/router';
import React from 'react';

import { Breadcrumb, Space } from '@sravni/react-design-system';
import { PreFooter } from '@sravni/react-pre-footer';
import { Html } from '@sravni/react-seo';

import { useMetadata } from '../../store/hooks/metadata';
import pageStyles from '../../styles/page.module.scss';
import { TReviewListQuery } from '../../types/router';
import { LegalDisclaimer } from '../LegalDisclaimer';

import { FAQ } from './components/FAQ';
import styles from './seo-blocks.module.scss';

export const SeoBlocks: React.FC = () => {
  const router = useRouter() as TRouter<TReviewListQuery>;
  const { asPath } = router;

  const [pathname] = asPath.split('?');
  const metadata = useMetadata(pathname);

  if (!metadata) return null;

  const { prefooter, breadcrumbs, contentBlocks } = metadata;

  const faqData = contentBlocks.find((item) => item.type === 'faq');
  const htmlText = contentBlocks.find((block) => block.type === 'html')?.text;

  return (
    <>
      <div className={pageStyles.container}>
        <div className={pageStyles.mainColumn}>
          <div className={pageStyles.mainColumnInner}>
            {htmlText && <Html text={htmlText} className={styles['seo-text']} />}
            {faqData && <FAQ data={faqData} />}
            <Space className="h-mb-24">
              <Breadcrumb>
                {breadcrumbs.map(({ url, title }) => (
                  <Breadcrumb.Item href={url} key={url}>
                    {title}
                  </Breadcrumb.Item>
                ))}
              </Breadcrumb>
            </Space>
            <LegalDisclaimer />
          </div>
        </div>
      </div>
      <PreFooter columns={prefooter} />
    </>
  );
};
